import { formatDate, MOMENT_FORMATS } from '../../../../utils/dateFormat';

export const GUEST_LIST_ROWS_PER_PAGE = 5;

export const getGuestAttendeeId = (guest) =>
  guest?.attendeeId ?? guest?.bookingId ?? guest?.id ?? null;

export const formatGuestPaidAt = (paidAt) => formatDate(paidAt, MOMENT_FORMATS.DATETIME) || '—';

export const PARTNER_GUEST_PAYMENT_FILTERS = [
  { id: 'all', label: 'All' },
  { id: 'paid', label: 'Paid' },
  { id: 'pending', label: 'Pending' },
  // { id: 'waitlist', label: 'Waitlist' },
  { id: 'outOfPlatform', label: 'Out of Platform' },
];

export const filterPartnerGuests = (guests, { search = '', paymentFilter = 'all' } = {}) => {
  const query = search.trim().toLowerCase();

  return guests.filter((guest) => {
    if (paymentFilter === 'paid' && guest.paymentStatus !== 'Paid') {
      return false;
    }
    if (paymentFilter === 'pending' && guest.paymentStatus !== 'Pending') {
      return false;
    }
    // if (paymentFilter === 'waitlist' && guest.rsvpStatus !== 'Waitlist') {
    //   return false;
    // }
    if (paymentFilter === 'outOfPlatform' && !guest.outOfPlatform) {
      return false;
    }

    if (!query) {
      return true;
    }

    const haystack = [guest.name, guest.email, guest.phone, guest.profession]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();

    return haystack.includes(query);
  });
};
